module.exports = "/images/vendor/vue-paycard/src/1.jpg?1b52b6d1e75beff0b0c855132302aec9";